export function getTenantClerkOrgId(tenant) {
  return tenant?.clerkOrgId || null;
}

export function isTenantLinkedToClerk(tenant) {
  return Boolean(getTenantClerkOrgId(tenant));
}
